module.exports = __webpack_public_path__ + "static/media/login-bg.033bc9ea.jpg";